<mat-form-field style="width: 100%;">
  <mat-label>{{ 'BIURO_PROJECT_MANAGER' | translate }}</mat-label>
  <input type="text" matInput [formControl]="managerCtrl" [matAutocomplete]="managerAuto">
  <mat-autocomplete #managerAuto="matAutocomplete" [displayWith]="displayFn">
    <mat-option *ngFor="let manager of filteredManagers | async" [value]="manager">
      {{manager.user.firstName}} {{manager.user.lastName}}
    </mat-option>
  </mat-autocomplete>
  <mat-error>{{ 'COMMON.REQUIRED_FIELDS' | translate }}</mat-error>
</mat-form-field>